import axiosInstance from './axiosInstance';
import { API_ROUTES } from './constants';

// Create a new blog
export const createBlog = async (blogData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.BLOGS.CREATE, blogData);
    return response.data;
  } catch (error) {
    console.error('Error creating blog:', error);
    throw error;
  }
};

// Update an existing blog
export const updateBlog = async (blogId, updateData) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.BLOGS.UPDATE}/${blogId}`, updateData);
    return response.data;
  } catch (error) {
    console.error('Error updating blog:', error);
    throw error;
  }
};

// Get all blogs with optional query parameters
export const getBlogs = async (queryParams = {}) => {
  try {
    const params = {
      page: queryParams?.page || 1,
      search: queryParams?.search || '',
      sortBy: queryParams?.sortBy || 'createdAt',
      category: queryParams?.category || '',
    };

    const response = await axiosInstance.get(API_ROUTES.BLOGS.GET, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching blogs:', error);
    throw error;
  }
};

// Get single blog
export const getBlog = async (blogId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.BLOGS.GET_SINGLE_BLOG}/${blogId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching blog:', error);
    throw error;
  }
};

// Delete one or multiple blogs
export const deleteBlogs = async (blogIds) => {
  try {
    const response = await axiosInstance.delete(API_ROUTES.BLOGS.DELETE, {
      data: {
        ids: blogIds
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting blogs:', error);
    throw error;
  }
};

const blogsApi = {
  createBlog,
  updateBlog,
  getBlogs,
  deleteBlogs,
};

export default blogsApi;
